import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';

import { WarningInfoBox } from '../warning-info-box';

export const StyledCloneText = styled.p<{ fontWeight?: string }>`
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  font-weight: ${({ fontWeight = '400' }) => fontWeight};
  color: ${({ theme }) => theme.colors.text.lighter};
  margin-bottom: 1.6rem;
`;

export const StyledCloneContentContainer = styled.div`
  margin-top: 2.4rem;
  margin-bottom: 2.4rem;
`;

export const StyledCloneInstructionText = styled.span`
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  color: ${({ theme }) => theme.colors.text.main};
`;

export const StyledCloneIcon = styled(FontAwesomeIcon)`
  && {
    height: 1.9rem;
    width: 1.6rem;
  }
`;

export const StyledWarningBox = styled(WarningInfoBox)`
  margin-top: 1.6rem;
`;
